import React from 'react';
import {GatsbyImage} from "gatsby-plugin-image";
import styled from "styled-components";
import {Container} from "@acc-monorepo/gatsby-stories/styles/shared";
import LinkButton from "@acc-monorepo/gatsby-stories/buttons/LinkButton";
import {downloadAndLog} from "../../utils/journals";
import {StyledSection} from "./pageStyles";

const StyledJournalSection = styled(StyledSection)`
  .flexColumnRow {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .journal-image {
    display: block;
    background: none;
    border: none;
    margin-bottom: 2rem;
    cursor: pointer;

    p {
      text-align: center;
      margin: 1rem 0;
      font-size: 1rem;
      color: #646e78;
    }
  }
  .content {
    h2 {
      margin-top: 0;
    }
    p {
      margin-bottom: 1rem;
    }
  }
  
  ul {
    list-style-type: none;
  }
  li {
    display: flex;
    align-items: flex-start;
  }
  li::before {
    content: "";
    background: currentColor;
    display: inline-block;
    flex: 0 0 auto;
    height: 0.3em;
    width: 0.3em;
    border-radius: 50%;
    margin-left: -1rem;
    margin-top: calc((1.45em - 0.3em)/2); // line height, minus marker size, divided by 2 to position in center of first line
    margin-right: 0.75rem;
  }
  
  @media(min-width: 768px) {
    .flexColumnRow {
      flex-direction: row;
    }
    
    .content, .journal-image {
      width: 50%;
      padding: 3rem;
    }
    .journal-image {
      margin-bottom: 0;
      padding: 3rem;
    }
    li {
      font-size: 0.9rem;
    }
  }
  @media(min-width: 1024px) {
    .image {
      margin-bottom: 0;
      padding: 3rem 6.5rem;
    }
  }
`

export const JournalSection = ({volume, journalName, position, ...props}) => {
  return (
    <StyledJournalSection style={{backgroundColor: position % 2 === 0 ? "var(--offwhite)" : "white"}}>
      <Container className="flexColumnRow">
        <button
          className="journal-image"
          onClick={() => downloadAndLog(volume.url, journalName)}
        >
          <GatsbyImage
            image={volume.imageData}
            alt={`${journalName} Vol. ${volume.number}, ${volume.year} cover`}
          />
          <p><i>Click the cover to view or download the entire journal</i></p>
        </button>
        <div className="content">
          <h2>{(position === 0) ? "Latest" : volume.year} Edition</h2>
          <p>
            This journal contains the following articles.<br />
            <i>Make a selection from the list below:</i>
          </p>
          <ul>
            {volume.articles.map((article, i) => (
              <li key={article.name}>
                <LinkButton onClick={() => downloadAndLog(volume.url + '#page=' + article.page.toString(), journalName)} target="_blank">{article.name}</LinkButton>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </StyledJournalSection>
  )
}

export default JournalSection
